import React from "react";
import { couriersContent } from "../mock";
import useReveal from "../hooks/useReveal";

// Recreated courier brand marks using styled text to approximate the originals
const CourierLogo = ({ name }) => {
  const base =
    "flex items-center justify-center h-20 grayscale-0 opacity-90 hover:opacity-100 hover:scale-105 transition-all duration-300";
  switch (name) {
    case "GLS":
      return (
        <div className={base}>
          <span className="relative font-extrabold text-3xl text-[#061A66] tracking-tight">
            <span className="absolute -left-3 top-1 text-[#F5A623] text-2xl">{"\u279c"}</span>GLS
          </span>
        </div>
      );
    case "UPS":
      return (
        <div className={base}>
          <span className="flex flex-col items-center justify-center w-16 h-16 rounded-t-[40px] rounded-b-lg bg-[#5A3A22] shadow">
            <span className="text-[#FFB500] font-extrabold text-xl italic leading-none mt-3">ups</span>
            <span className="w-6 h-1.5 bg-[#FFB500] rounded-full mt-1" />
          </span>
        </div>
      );
    case "BRT":
      return (
        <div className={base}>
          <div className="flex flex-col items-center">
            <span className="font-extrabold text-3xl text-[#D6006E] leading-none">BRT</span>
            <span className="text-[8px] font-bold tracking-widest text-[#D6006E] mt-1">CORRIERE ESPRESSO</span>
          </div>
        </div>
      );
    case "DPD":
      return (
        <div className={base}>
          <div className="flex items-center gap-1">
            <span className="font-extrabold text-2xl text-[#D6006E] leading-none">BRT</span>
            <span className="font-extrabold text-xl text-[#D6006E]">DPD</span>
          </div>
        </div>
      );
    case "POSTE":
      return (
        <div className={base}>
          <span className="font-bold text-2xl text-[#003399]">
            Poste<span className="font-normal">italiane</span>
          </span>
        </div>
      );
    case "CRONO":
      return (
        <div className={base}>
          <div className="flex flex-col items-center leading-none">
            <span className="font-extrabold text-2xl text-[#003399]">Crono</span>
            <span className="text-[10px] font-semibold text-[#003399]">Posteitaliane</span>
          </div>
        </div>
      );
    case "SKYNET":
      return (
        <div className={base}>
          <div className="flex flex-col items-center leading-none">
            <span className="font-black text-2xl italic">
              <span className="text-[#E11B22]">SKY</span>
              <span className="text-[#1B1B1B]">NET</span>
            </span>
            <span className="text-[9px] font-bold tracking-[0.3em] text-[#F5A623]">TNT</span>
          </div>
        </div>
      );
    default:
      return null;
  }
};

const Couriers = () => {
  const ref = useReveal();
  return (
    <section className="bg-white pb-16 md:pb-24">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div ref={ref} className="reveal grid md:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <h2 className="heading-navy font-bold text-3xl md:text-4xl leading-tight tracking-tight">
              {couriersContent.title}
            </h2>
            <p className="mt-6 text-[#5a5a66] text-[16px] leading-relaxed">
              {couriersContent.paragraph}
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-4 gap-6 items-center">
            {couriersContent.logos.map((name) => (
              <CourierLogo key={name} name={name} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Couriers;
